import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { BreadCrumb } from "../../Layout/Common/breadCrumb";
import { isValidArray, normalizePath, normalizeUrlPath } from "../../Layout/Common/common";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { BrandSkeleton } from "../../Skeleton/brandSkeleton";
import { Link, useParams } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { GlobalContext } from "../../Context/GlobalContext";

export const ModelGridContainer = ({ models, handleModelSelected }) => {
  const [Breadcrumb, setBreadcrumb] = useState([]);
  const [manufacturer, setManufacturer] = useState(null);
  const [filterAlpha, setFilterAlpha] = useState(null);
  const [selectedAlpha, setSelectedAlpha] = useState("ALL");
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [modelList, setModelList] = useState(null);
  const objectRef = useRef();
  useEffect(() => {
    setModelList(models);
    objectRef.current = models;
    let nameList = models.map((item) => item.modelName.charAt(0).toUpperCase());
    const uniqueNames = [...new Set(nameList)];
    setFilterAlpha(uniqueNames.sort((a, b) => a.localeCompare(b)));
    setSelectedAlpha("ALL");
  }, [models]);

  const handleFilterAlpha = (alpha) => {
    setSelectedAlpha(alpha);
    if (alpha == "ALL") setModelList(objectRef.current);
    else {
      let item = objectRef.current.filter((item) => String(item.modelName).toUpperCase().startsWith(alpha));
      setModelList(item);
    }
  };

  const handleSearch = (e) => {
    try {
      let txt = e?.target?.value;
      let item = objectRef.current.filter((item) => String(item.modelName).toUpperCase().includes(txt.toUpperCase()));
      setModelList(item);
    } catch (e) {
      console.error("e", e);
    }
  };

  return (
    <Fragment>
      {isValidArray(modelList) && (
        <section className="brand-list-section">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-sm-6 col-lg-6 shop-brand-title">
                <h1>Shop By Model</h1>
              </div>
              <div className="col-sm-6 col-lg-6">
                <div className="shop-brand-search position-relative float-end">
                  <input
                    className="form-control me-2"
                    type="text"
                    name="searchbox"
                    placeholder="Search here"
                    aria-label="Search"
                    onChange={handleSearch}
                    autoComplete="off"
                  />
                  <span className="wes-search" />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-12">
                <div className="brands-list">
                  <ul>
                    <li>
                      <a
                        role="button"
                        onClick={() => handleFilterAlpha("ALL")}
                        className={`${selectedAlpha == "ALL" && "active"}`}
                      >
                        All
                      </a>
                    </li>
                    {filterAlpha &&
                      filterAlpha.map((item) => (
                        <li className="border-link">
                          <a
                            role="button"
                            className={`${selectedAlpha == item && "active"}`}
                            onClick={() => handleFilterAlpha(item)}
                          >
                            {item}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
            <TransitionGroup className={"row row-equal-coloumn"}>
              {isValidArray(modelList) ? (
                modelList.map((row, index) => (
                  <CSSTransition key={row.id} timeout={500} classNames="fade">
                    <div className="col-4 col-sm-3 col-md-3 col-lg-3 mt-3 mt-lg-4">
                      <div className="branding-list">
                        <Link
                          to={"/" + row.modelUrl}
                          onClick={() => handleModelSelected(row)}
                          className="brand-list-effect"
                        >
                          <ImageWithDefault
                            src={row.brandImage}
                            style={{ width: "180px", height: "100px", objectFit: "contain" }}
                          />
                          <span>
                            {row.modelName}
                            <span></span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </CSSTransition>
                ))
              ) : objectRef?.current ? (
                <CSSTransition key={-1} timeout={500} classNames="fade">
                  <div className="container d-flex mt-12 mt-lg-4">
                    <div style={{ margin: "auto" }}>No Result Found</div>
                  </div>
                </CSSTransition>
              ) : (
                <CSSTransition key={0} timeout={500} classNames="fade">
                  <BrandSkeleton count={4} />
                </CSSTransition>
              )}
            </TransitionGroup>
          </div>
        </section>
      )}
    </Fragment>
  );
};
